export const CoOwnershipType = {
    numberOfUnits: "numberOfUnits",
    operatingCosts: "operatingCosts",
    syndicProcedures: "syndicProcedures",
};
